/* Oddsaint motion: scroll reveals, a scroll progress bar and a header that
   settles as you scroll.

   Two rules this file sticks to:
   - The `reveal` class is only ever added by this script, so if scripts fail
     nothing is left invisible.
   - Reduced-motion users get the page with no movement at all. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ------------------------------------------------------------------
     Scroll reveals
     ------------------------------------------------------------------ */

  // Content wrappers rather than whole sections, so the dark panels do not
  // fade their own background in. Grids stagger their items instead.
  // [selector, stagger in ms, extra class]
  var groups = [
    ['.drop-grid__head', 0, ''],
    ['.drop-grid .product-grid__item', 60, ''],
    ['.games .game', 60, ''],
    ['.fit-spec__eyebrow', 0, ''],
    ['.fit-spec__title', 0, ''],
    ['.fit-spec__item', 80, ''],
    ['.image-with-text__media', 0, 'reveal--zoom'],
    ['.image-with-text__content', 0, ''],
    ['.newsletter__inner', 0, '']
  ];

  var items = [];
  var observer = null;
  var observerRan = false;

  function show(node) {
    node.classList.add('is-revealed');
  }

  function onScreen(node) {
    var box = node.getBoundingClientRect();
    return box.top < window.innerHeight - 60 && box.bottom > 0;
  }

  function collect(root) {
    var found = [];
    groups.forEach(function (group) {
      var nodes = (root || document).querySelectorAll(group[0]);
      Array.prototype.forEach.call(nodes, function (node, index) {
        if (node.classList.contains('reveal')) return;
        node.classList.add('reveal');
        if (group[2]) node.classList.add(group[2]);
        if (group[1]) {
          node.style.setProperty('--reveal-delay', (index % 4) * group[1] + 'ms');
        }
        found.push(node);
        items.push(node);
      });
    });
    return found;
  }

  function watch(found) {
    if (!found.length) return;

    if (!('IntersectionObserver' in window)) {
      found.forEach(show);
      return;
    }

    if (!observer) {
      // The observer always delivers an initial batch, intersecting or not, so
      // a callback that never runs at all means it is not working here.
      observer = new IntersectionObserver(
        function (entries) {
          observerRan = true;
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            show(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px' }
      );
    }

    found.forEach(function (node) {
      if (onScreen(node)) {
        show(node);
        return;
      }
      observer.observe(node);
    });
  }

  watch(collect(document));

  setTimeout(function () {
    if (!observerRan) items.forEach(show);
  }, 2500);

  /* ------------------------------------------------------------------
     Scroll progress and header
     ------------------------------------------------------------------ */
  var header = document.querySelector('[data-header]');
  var bar = document.createElement('div');
  bar.className = 'scroll-progress';
  document.body.appendChild(bar);

  // The page height is measured separately from the scroll handler, so
  // scrolling never forces a layout. Deliberately no requestAnimationFrame
  // here: a hidden tab suspends those callbacks, which can strand a throttle
  // flag and freeze the bar. The work per event is two reads and a toggle.
  var maxScroll = 0;

  function measure() {
    maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    update();
  }

  function update() {
    var ratio = maxScroll > 0 ? Math.min(1, Math.max(0, window.scrollY / maxScroll)) : 0;
    bar.style.setProperty('--progress', ratio);
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 40);
  }

  measure();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);

  // Images and reveals change the page height after first paint.
  if ('ResizeObserver' in window) {
    new ResizeObserver(measure).observe(document.body);
  }

  /* Theme editor: sections are re-rendered without a page load. */
  document.addEventListener('shopify:section:load', function (event) {
    watch(collect(event.target));
    measure();
  });
})();
